"use client";

import React, { Suspense } from "react";
import { useSearchParams } from "next/navigation";
import { SparklesIcon } from "@heroicons/react/24/outline";

import LoadingSpinner from "@/components/common/LoadingSpinner";
import { useAuthSession } from "@/hooks/useAuthSession";
import AIDashboard from "@/components/ai/AIDashboard";
import PageHeaderWithStats from "@/components/common/PageHeaderWithStats";
import { Footer } from "@/components/Footer";

const AIAssistantContent: React.FC = () => {
  const { isLoading } = useAuthSession();
  const searchParams = useSearchParams();
  const query = searchParams.get("query");

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-white mt-[60px] sm:mt-[80px]">
      {/* Header with PageHeaderWithStats component (without stats) */}
      <PageHeaderWithStats
        badge={{ text: "Prana AI", showPulse: true }}
        title={{ main: "Meet", highlighted: "Prana — Your AI Wellness Guide" }}
        description="Prana helps you with personalized yoga sequences, workout plans, nutrition coaching, and expert wellness advice tailored to your journey."
        stats={[]}
      />

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 zoom-container pb-20 md:pb-8 mt-[-100px] sm:mt-[-80px]">
        <AIDashboard initialQuery={query} />
      </main>
    </div>
  );
};

const AIAssistantPage: React.FC = () => {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-slate-50 flex items-center justify-center">
          <LoadingSpinner />
        </div>
      }
    >
      <AIAssistantContent />
      <Footer />
    </Suspense>
  );
};

export default AIAssistantPage;
